var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "process" }, [
    _c("div", { staticClass: "box" }, [
      _c("img", {
        attrs: { src: require("../../../static/image/submit@2x.png"), alt: "" }
      }),
      _vm._v(" "),
      _c("p", [_vm._v("提交订单")]),
      _vm._v(" "),
      _c("p", { staticClass: "mar-top-10" }, [_vm._v(_vm._s(_vm.createTime))])
    ]),
    _vm._v(" "),
    _vm._m(0),
    _vm._v(" "),
    _vm._m(1),
    _vm._v(" "),
    _vm._m(2),
    _vm._v(" "),
    _vm._m(3),
    _vm._v(" "),
    _vm._m(4),
    _vm._v(" "),
    _vm._m(5),
    _vm._v(" "),
    _vm._m(6),
    _vm._v(" "),
    _c("div", { staticClass: "box" }, [
      _c("img", {
        attrs: {
          src: require("../../../static/image/complete@2x.png"),
          alt: ""
        }
      }),
      _vm._v(" "),
      _c("p", [_vm._v("已完成")]),
      _vm._v(" "),
      _c("p", { staticClass: "mar-top-10" }, [_vm._v(_vm._s(_vm.receiveTime))])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "spot" }, [
      _c("img", {
        attrs: { src: require("../../../static/image/line@2x.png"), alt: "" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "box" }, [
      _c("img", {
        attrs: { src: require("../../../static/image/payment@2x.png"), alt: "" }
      }),
      _vm._v(" "),
      _c("p", [_vm._v("付款成功")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "spot" }, [
      _c("img", {
        attrs: { src: require("../../../static/image/line@2x.png"), alt: "" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "box" }, [
      _c("img", {
        attrs: {
          src: require("../../../static/image/delivery@2x.png"),
          alt: ""
        }
      }),
      _vm._v(" "),
      _c("p", [_vm._v("商品出库")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "spot" }, [
      _c("img", {
        attrs: { src: require("../../../static/image/line@2x.png"), alt: "" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "box" }, [
      _c("img", {
        attrs: {
          src: require("../../../static/image/transport@2x.png"),
          alt: ""
        }
      }),
      _vm._v(" "),
      _c("p", [_vm._v("等待收货")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "spot" }, [
      _c("img", {
        attrs: { src: require("../../../static/image/line@2x.png"), alt: "" }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-ac1907d6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-ac1907d6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/status/statusFour.vue
// module id = null
// module chunks = 